import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles.ts";

export const useCreateContractPaneStyles = () => {
    const theme = useTheme();
    return createSxStyles({
        content: {
            flex: 1,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
        },
        toggleContainer: {
            display: "flex",
            gap: 1,
            marginBottom: theme.spacing(3),
            padding: 0.5,
            backgroundColor: theme.palette.grey[200],
            borderRadius: "8px",
        },
        toggleButton: {
            flex: 1,
            padding: "12px 16px",
            background: theme.palette.grey[200],
            border: "none",
            borderRadius: "6px",
            fontWeight: 500,
            cursor: "pointer",
            transition: "all 0.2s",
            fontSize: "14px",
            color: theme.palette.text.secondary,
        },
        toggleButtonActive: {
            flex: 1,
            padding: "12px 16px",
            background: theme.palette.primary.main,
            border: "none",
            borderRadius: "6px",
            fontWeight: 500,
            cursor: "pointer",
            transition: "all 0.2s",
            fontSize: "14px",
            color: theme.palette.common.white,
            "&:hover": {
                backgroundColor: "rgb(91, 105, 200)",
            },
        },
        toggleButtonDisabled: {
            flex: 1,
            padding: "12px 16px",
            background: theme.palette.grey[200],
            border: "none",
            borderRadius: "6px",
            fontWeight: 500,
            cursor: "pointer",
            transition: "all 0.2s",
            fontSize: "14px",
            color: theme.palette.text.disabled,
            opacity: 0.6,
        },
        resultsSection: {
            marginTop: theme.spacing(2),
        },
        resultsSectionTitle: {
            fontSize: "14px",
            fontWeight: 600,
            color: theme.palette.primary.dark,
            marginBottom: theme.spacing(1),
            marginTop: theme.spacing(2),
        },
        fieldRow: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            padding: theme.spacing(1),
            borderBottom: `1px solid ${theme.palette.grey[200]}`,
            "&:last-child": {
                borderBottom: "none",
            },
        },
        fieldLabel: {
            fontSize: "13px",
            fontWeight: 500,
            color: theme.palette.text.secondary,
            minWidth: "140px",
        },
        fieldValue: {
            fontSize: "13px",
            color: theme.palette.text.primary,
            flex: 1,
            marginLeft: theme.spacing(2),
        },
        counterpartyCardWrapper: {
            position: "relative",
            marginBottom: theme.spacing(1),
            "&:hover .counterparty-delete-button": {
                visibility: "visible",
            },
        },
        counterpartyCard: {
            backgroundColor: theme.palette.grey[50],
            border: `1px solid ${theme.palette.grey[200]}`,
            borderRadius: "8px",
            padding: theme.spacing(2),
        },
        counterpartyDeleteButton: {
            position: "absolute",
            top: 8,
            right: 8,
            padding: "4px",
            visibility: "hidden",
        },
        counterpartyDeleteIcon: {
            fontSize: 16,
            color: theme.palette.error.main,
        },
        counterpartyName: {
            fontSize: "14px",
            fontWeight: 500,
            color: theme.palette.primary.dark,
            marginBottom: theme.spacing(0.5),
        },
        counterpartyDetail: {
            fontSize: "12px",
            color: theme.palette.text.secondary,
        },
        noResultsMessage: {
            textAlign: "center",
            padding: theme.spacing(3),
            color: theme.palette.text.secondary,
            fontStyle: "italic",
        },
        editableSectionContainer: {
            width: "100%",
        },
        addPartyContainer: {
            marginTop: theme.spacing(2),
        },
    });
};
